import { render, staticRenderFns } from "./Organizacao.vue?vue&type=template&id=33117be5&"
import script from "./Organizacao.vue?vue&type=script&lang=js&"
export * from "./Organizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports